module.exports = __webpack_public_path__ + "img/phone.bf9a4e22.svg";